import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import facebookIcon from '../assests/images/facebook.png';
import twitterIcon from '../assests/images/twitter.png';
import linkedinIcon from '../assests/images/linkedin.png';
import instagramIcon from '../assests/images/instagram.png';

const Topbar = () => {
  return (
    <div style={{ width: '100%', backgroundColor: '#024A59' }}>
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '6px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          color: 'white',
          fontSize: '12px',
        }}
      >
        {/* Left Section (Hidden on mobile) */}
        <div
          className="topbar-left"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            flex: '1 1 300px',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Mail color="#FFA916" size={14} />
            <a
              href="mailto:info@statify.co.ke"
              style={{ textDecoration: 'none', color: 'white' }}
            >
              info@statify.co.ke
            </a>
          </div>
        </div>

        {/* Right Section (Always visible) */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flex: '1 1 300px',
            justifyContent: 'flex-end',
            gap: '15px',
            marginTop: '6px',
          }}
        >
          <div
            style={{ color: 'white', cursor: 'pointer' }}
            onClick={() => window.open('https://wa.me/254728813009', '_blank')}
          >
            +254 728 813009/+254 796 265933
          </div>

          {/* Social Icons */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {[facebookIcon, twitterIcon, linkedinIcon, instagramIcon].map((icon, i) => (
              <img
                key={i}
                src={icon}
                alt="social"
                style={{
                  width: '22px',
                  height: '22px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  const links = [
                    'https://facebook.com',
                    'https://twitter.com',
                    'https://linkedin.com',
                    'https://instagram.com',
                  ];
                  window.open(links[i], '_blank');
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Hide left section on small screens */}
      <style>{`
        @media (max-width: 768px) {
          .topbar-left {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Topbar;

